import { defineMessages } from 'react-intl';

export default defineMessages({
  ratingLabel: {
    id: 'bundlePdp.ratingLabel',
    defaultMessage: 'Product Rating',
  },
  onSaleBadgeLabel: {
    id: 'bundlePdp.onSaleBadgeLabel',
    defaultMessage: 'On Sale',
  },
  affirmLogoAlt: {
    id: 'bundlePdp.affirmLogoAlt',
    description: 'Message for affirmLogo Alt',
    defaultMessage: 'Affirm logo',
  },
  affirmLegendWithPriceFragmentOne: {
    id: 'bundlePdp.affirmLegendWithPriceFragmentOne',
    defaultMessage: 'As low as {price} {apr}',
  },
  affirmLegendWithPriceFragmentTwo: {
    id: 'bundlePdp.affirmLegendWithPriceFragmentTwo',
    defaultMessage: 'up to 36 months with {affirmLogo}',
  },
  affirmAPRText: {
    id: 'bundlePdp.affirmAPRText',
    defaultMessage: 'at 0% APR',
  },
});
